import { IconName } from '@/app/components/ui/Icon';

export const clientStatusIconMap: Record<string, IconName> = {
  not_started: 'time-fill',
  in_progress: 'time-fill',
  completed: 'dot-large',
  onboarding: 'time-fill',
  live: 'dot-large',
  disabled: 'dot-large',
};

export const agencyStatusIconMap: Record<string, IconName> = {
  active: 'select-box-circle-fill',
  inactive: 'dot-large',
};

export const campaignChannelIcons: Record<string, IconName> = {
  email: 'mail-fill',
  call: 'phone-fill',
  slack: 'slack-filled',
  linkedin: 'linkedin-filled',
};

export const conversationTypeIconMap: Record<string, IconName> = {
  'email-draft': 'mail-line',
  'email-review': 'mail-line',
  'email-incoming': 'mail-download-line',
  'email-outgoing': 'mail-upload-line',
  'linkedin-outgoing': 'linkedin-box-fill',
  'linkedin-incoming': 'linkedin-box-fill',
  'linkedin-draft': 'linkedin-box-fill',
  'linkedin-review': 'linkedin-box-fill',
  'linkedin-not_delivered': 'linkedin-box-fill',
  'imessage-outgoing': 'chat-3-line',
  'imessage-incoming': 'chat-3-line',
  'imessage-draft': 'chat-3-line',
  'email-not_delivered': 'mail-line',
  archived: 'archive-line',
};

export const conversationTimelineIcon: Record<string, IconName> = {
  'email-draft': 'gmail-color',
  'email-review': 'gmail-color',
  'email-incoming': 'gmail-color',
  'email-outgoing': 'gmail-color',
  'linkedin-outgoing': 'linkedin-color',
  'linkedin-incoming': 'linkedin-color',
  'linkedin-draft': 'linkedin-color',
  'linkedin-review': 'linkedin-color',
  'email-not_delivered': 'gmail-color',
  'linkedin-not_delivered': 'linkedin-color',
  'imessage-incoming': 'imessage-color',
  'imessage-outgoing': 'imessage-color',
  'imessage-not_delivered': 'imessage-color',
  'imessage-draft': 'imessage-color',
};

export const taskChannelIcons: Record<string, IconName> = {
  email: 'mail-fill',
  linkedin: 'linkedin-box-fill',
  imessage: 'chat-3-line',
};

export const taskPriorityIcons: Record<string, IconName> = {
  low: 'arrow-down-s-line',
  medium: 'subtract-fill',
  high: 'arrow-up-s-line',
};

export const taskStatusIcons: Record<string, IconName> = {
  completed: 'select-box-fill',
  in_progress: 'time-fill',
  planned: 'calendar-event-fill',
};

export const taskTypeIcons: Record<string, IconName> = {
  follow_up: 'mail-upload-fill',
};

export const pipelineStageIcons: Record<string, IconName> = {
  intro: 'calendar-todo-line',
  discussion: 'question-answer-line',
  closing: 'shakehand',
};

export const campaignStatusIcons: Record<string, IconName> = {
  draft: 'draft-fill',
  ready: 'select-box-circle-fill',
  not_started: 'dot-large',
  scheduled: 'time-line',
  completed: 'check',
  running: 'play-large-fill',
  paused: 'pause-fill',
  ended: 'square-line',
  error: 'calendar-event-line',
  archived: 'archive-line',
};

export const companyStatusIcons: Record<string, IconName> = {
  target: 'crosshair-line',
  engaged: 'question-answer-line',
  converted: 'select-box-circle-line',
  excluded: 'subtract-fill',
  archived: 'archive-line',
};

export const contactStatusIcons: Record<string, IconName> = {
  target: 'crosshair-line',
  engaged: 'question-answer-fill',
  converted: 'select-box-circle-fill',
  excluded: 'indeterminate-circle-fill',
  archived: 'archive-fill',
};

export const collateralUrlTypeIcons: Record<string, IconName> = {
  pdf: 'file-pdf',
  doc: 'file-doc',
  docx: 'file-docx',
  pptx: 'file-pptx',
  xls: 'file-xls',
  xlsx: 'file-xlsx',
  txt: 'file-txt',
  png: 'file-png',
  jpg: 'file-jpg',
  jpeg: 'file-jpg',
  gif: 'file-gif',
  svg: 'file-jpg',
  mov: 'file-mov',
  mp4: 'file-mp4',
  mp3: 'file-line',
  zip: 'file-zip',
  url: 'link',
  json: 'file-line',
};

export const targetListStatusIcons: Record<string, IconName> = {
  ready: 'check-circle-fill',
  draft: 'draft-fill',
  failed: 'close-circle-fill',
  building: 'loading',
  archived: 'archive-line',
};

export const userStatusIcons: Record<string, IconName> = {
  pending: 'time-fill',
  active: 'check-circle-fill',
  suspended: 'close-circle-fill',
  deleted: 'close-circle-fill',
};

export const userLinkedinStatusIcons: Record<string, IconName> = {
  connected: 'check',
  disconnected: 'cross-fill',
  connecting: 'loader-2-fill',
};

export const userTableChannelIcons: Record<string, IconName> = {
  linkedin: 'linkedin-box-fill',
  linkedin_premium: 'linkedin-box-fill',
  mailbox: 'mail-line',
  email: 'gmail',
  google: 'gmail-main-color',
  microsoft: 'outlook',
  outlook: 'outlook',
  imessage: 'imessage-color',
};

export const consoleItemNodeIcons: Record<string, IconName> = {
  email: 'mail-fill',
  start: 'play-fill',
  end: 'square-fill',
  linkedin: 'linkedin-box-fill',
  imessage: 'chat-3-line',
  condition: 'poker-diamonds-fill',
  companies: 'building-4-fill',
  hubspot: 'hubspot',
  salesforce: 'salesforce',
  attio: 'attio',
  pipedrive: 'pipedrive',
  slack: 'slack-logo',
  webhook: 'webhook-logo',
};

export const userMailboxStatusIcons: Record<string, IconName> = {
  connected: 'check-circle-fill',
  inactive: 'error-warning-fill',
  pending: 'time-fill',
  disconnected: 'cross-fill',
};

export const signalEntityIcons: Record<string, IconName> = {
  linkedin: 'linkedin-box-fill',
  email: 'mail-fill',
  form: 'draft-fill',
  page: 'global-fill',
  response: 'mail-star-fill',
  persona: 'user-fill',
  icp: 'building-line',
  imessage: 'chat-3-line',
};

export const intentIcons: Record<string, IconName> = {
  meeting: 'calendar-line',
  pricing: 'coin-line',
  info: 'information-line',
  support: 'customer-service-line',
  later: 'time-line',
  referral: 'user-shared-2-line',
  competitor: 'shake-hands-line',
  budget: 'currency-line',
  no_need: 'prohibited-2-line',
  wrong_persona: 'user-unfollow-line',
  requested: 'user-minus-line',
  other: 'circle-line',
};

export const configChannelIcons: Record<string, IconName> = {
  gmail: 'gmail-color',
  linkedin: 'linkedin-color',
  imessage: 'imessage-color',
};
